import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';

import { AuthService } from '../services/auth.service';

/** Allows the route when a valid session exists; refreshes access if expired but refresh token remains. */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.hasRefreshToken() && !auth.getAccessTokenSnapshot()) {
    return router.createUrlTree(['/login']);
  }

  return auth.ensureSessionReady().pipe(
    switchMap(() =>
      auth.isAuthenticated() ? of(true) : of(router.createUrlTree(['/login'])),
    ),
    catchError(() => of(router.createUrlTree(['/login']))),
  );
};
